import { HOUSEHOLD_MEMBER_AVATARS } from '../caremap/CareMapFactory';
import { CareMapState } from '../caremap/CareMapState';

export class DefaultAvatarProvider {
    getDefaultAvatar = ({ careMap, inUse = [], preferredAvatar }: { careMap: CareMapState; inUse?: string[]; preferredAvatar?: string }): string => {
        const state = careMap.getActiveCaremap();

        const avatarsInUse = [
            ...inUse,
            state?.patient.avatar,
            ...(state?.household.members || []).map(mem => mem.avatar)
        ];

        if (preferredAvatar && !avatarsInUse.includes(preferredAvatar)) {
            return preferredAvatar;
        }

        const unusedAvatars = HOUSEHOLD_MEMBER_AVATARS.filter(a => !avatarsInUse.includes(a));

        return unusedAvatars[0] || HOUSEHOLD_MEMBER_AVATARS[0];
    };
}
